/**
 * Some shared functions for Recaptcha, for use in Donate Form and Ticketing Form
 */

export default class RecaptchaUtils {
	constructor(opts) {
		this.loaded = false;

		this.ui = {
			tokenField: $('#recaptchaToken'),
			loadedField: $('#recaptchaLoaded'),
		}

		$(window).on('load', () => {
			if(typeof grecaptcha === 'undefined') {
				console.log("RecaptchaUtils.constructor()", "No grecaptcha object found");
				return;
			}

			grecaptcha.ready(this.onLoad.bind(this));
		});
	}

	onLoad() {
		console.log('RecaptchaUtils.onLoad()', 'Google recaptcha has been loaded.');
		this.loaded = true;
		this.ui.loadedField.val(true);
	}

	setToken(token) {
		console.log("RecaptchaUtils.setToken()", token);
		this.ui.tokenField.val(token);
	}

	reset() {
		console.log("RecaptchaUtils.reset()");
		grecaptcha.reset();
		this.ui.tokenField.val('');
	}
}